import { Row, Col, Pagination, Button, Form } from "react-bootstrap";
import BTable from "react-bootstrap/Table";

import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
// import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useEffect, useState } from "react";
import { left, right } from "../../assets/img";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export function Table({
  columns,
  data,
  setPageno,
  pagecount,
  show,
  pageno,
  color = "#000",
}) {
  const navigate = useNavigate();
  const [pagenumber, setPagenumber] = useState(1);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    globalFilter,
    setGlobalFilter,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: pageno ? pageno - 1 : 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );
  useEffect(() => {
    setPagenumber(pageIndex + 1);
  }, [pageIndex]);
  // console.log(pageCount,"page count",canPreviousPage,canNextPage);

  let totalPages = Math.ceil(data?.length / 10);

  return (
    <div className="table-design">
      {/* <Row className="">
        <Col className="">
          <div className="d-flex ac-je ps-2 mt-2">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          </div>
        </Col>
      </Row> */}
      <BTable
        size="sm"
        responsive
        {...getTableProps()}
        className=" table-border  table mb-0"
        //  variant="dark"
      >
        <thead className="fixed-header  ">
          {headerGroups.map((headerGroup, ind) => (
            <tr
              className=" thfiled table_header"
              {...headerGroup.getHeaderGroupProps()}
              key={ind}
            >
              {headerGroup.headers.map((column, indx) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th
                  className=" text-start    "
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  key={indx}
                  style={{ border: "none" }}
                >
                  <h4 className="text-start f2 fs-xs-10 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  py-2 px-1 white  text-nowrap">
                    {column.render("Header")}
                  </h4>

                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center py-3"
                style={{ fontWeight: "500", color: "#555" }}
              >
                No data available
              </td>
            </tr>
          ) : (
            page.map((row, i) => {
              prepareRow(row);
              return (
                <tr className="text-start f2" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, ind) => {
                    const isClickable = [].includes(cell.column.Header);

                    const { name, mobileno } = row.original;
                    // console.log("Clicked Client:", cell.column, isClickable);
                    return (
                      <td
                        style={{
                          border: "none",
                          color: color,
                          cursor: isClickable ? "pointer" : "default",
                          borderRight: "2px solid #d9d9d9 !important",
                          // display: "flex",
                          // alignItems: "baseline",
                          // flexDirection: "row",
                        }}
                        className="text-center f4 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 mt-2 gray2 list-data"
                        {...cell.getCellProps()}
                        key={ind}
                        onClick={() => {
                          if (isClickable) {
                            // Log ClientId, Name, Phone
                            // const { ClientID, name, mobileno } = row.original;
                            // console.log("Clicked Client:", {
                            //   name,
                            //   mobileno,
                            //   ClientID,
                            // });

                            navigate("/client-report");
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </BTable>

      {/* {show && !pagecount && (
      <Row className="justify-content-between table-show  p-1 w-100 bg-primary2">
        <Col className="d-flex ac-jb pagination_box  ">
          <p className="px-1 mb-0 f2 fs-xs-14 fs-sm-15 fs-md-16 fs-lg-17 fs-xl-18 fs-xxl-20">
            Total Pages 10
          </p>
          <Pagination className=" pointer mb-0 d-flex ac-js">
            {pagenumber > 1 && (
              // <img
              //   src={left}
              //   width={20}
              //   height={22}
              //   alt=""
              //   onClick={() => {
              //     setPagenumber((pagenumber) =>
              //       pagenumber > 1 ? pagenumber - 1 : 1
              //     );
              //   }}
              // />
              <PlayArrowIcon
                className="left-arrow"
                onClick={() => {
                  setPagenumber((pagenumber) =>
                    pagenumber > 1 ? pagenumber - 1 : 1
                  );
                }}
              />
            )}
            <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">1</button>
            <input
              type="number"
              min={1}
              max={pageCount}
              style={{ width: "25px", height: "25px" }}
              className="form-control1   text-center f2 fs-xs-14 fs-sm-15 fs-md-16 fs-lg-17 fs-xl-18 fs-xxl-20"
              value={pagenumber}
              onChange={(e) => {
                if (!Number(e.target.value)) {
                  setPagenumber(e.target.value);
                  return;
                }
                if (e.target.value > pageCount) {
                  gotoPage(pageCount - 1);
                  setPagenumber(pageCount);
                  return;
                }
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
                setPagenumber(e.target.value);
              }}
            />

            <img
              src={right}
              width={20}
              height={22}
              alt=""
              onClick={() => {
                setPagenumber(pagenumber + 1);
              }}
            />
            <PlayArrowIcon
              className="right-arrow"
              onClick={() => {
                setPagenumber(pagenumber + 1);
              }}
            />
          </Pagination>
        </Col>
      </Row>
      )} */}

      {show && pagecount && (
        <Row className="justify-content-between table-show my-2  w-100">
          <Col>
            <div className="d-flex ac-jb">
              <div className="d-flex flex-row ac-jc gap-2">
                <p className="px-1 mb-0">Total Pages</p>
                <input
                  type="number"
                  className="btn"
                  // className="form-control ml-2  p-1 py-1 text-center"
                  value={pagecount?.last_page}
                  disabled={true}
                />
              </div>
              <div className="d-flex flex-row ac-jc gap-2">
                <p className="px-1 mb-0">Page No</p>

                <Pagination className="gap-1 pointer m-0">
                  {/* <button
                  // style={{width:32,height:32}}
                  className="btn"
                  onClick={() => {
                    setPageno(
                      pagecount?.current_page == 1
                        ? pagecount?.current_page
                        : pagecount?.current_page - 1
                    );
                  }}
                > 
                <KeyboardArrowLeftIcon className="page-left-arrow" />
                 </button> */}
                  <PlayArrowIcon
                    onClick={() => {
                      setPageno(
                        pagecount?.current_page == 1
                          ? pagecount?.current_page
                          : pagecount?.current_page - 1,
                      );
                    }}
                    className="left-arrow"
                  />
                  <input
                    type="number"
                    className="btn"
                    // className="form-control ml-2  p-1 py-1 text-center"
                    value={pagecount?.current_page}
                    readOnly
                    onChange={(e) => {
                      setPageno(
                        e.target.value > pagecount.last_page
                          ? pagecount?.last_page
                          : e.target.value,
                      );
                    }}
                  />
                  {/* <button
                  className="btn"
                  // className="form-control ml-2  p-1 py-1 text-center"
                  onClick={() => {
                    setPageno(
                      pagecount?.current_page == pagecount?.last_page
                        ? pagecount?.last_page
                        : pagecount?.current_page + 1
                    );
                  }}
                >
                 <KeyboardArrowRightIcon className="page-left-arrow" /> 
                </button> */}
                  <PlayArrowIcon
                    onClick={() => {
                      setPageno(
                        pagecount?.current_page == pagecount?.last_page
                          ? pagecount?.last_page
                          : pagecount?.current_page + 1,
                      );
                    }}
                    className="right-arrow"
                  />
                </Pagination>
              </div>
            </div>
          </Col>
          {/* <Col>
                        <span >
                            <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">
                                {pagecount?.last_page}
                            </button>
                        </span>
                    </Col> */}
        </Row>
      )}
      {show && !pagecount && (
        <Row className="justify-content-between table-show my-2  w-100">
          <Col className="d-flex ac-js">
            <p className="px-1 mb-0">Total Pages</p>
            <input
              type="number"
              style={{ width: "30px" }}
              className="form-control ml-2  p-1 py-1 text-center"
              value={totalPages ?? 1}
              disabled={true}
            />
          </Col>
          <Col className="d-flex ac-je  ">
            <p className="px-1 mb-0"> Page No</p>
            <Pagination className="gap-1 pointer mb-0">
              <PlayArrowIcon
                className="left-arrow"
                onClick={() => {
                  previousPage();
                  if (canPreviousPage) {
                    setPageno(pageno - 1);
                  }
                }}
                disabled={!canPreviousPage}
              />
              {/* <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">1</button> */}
              <input
                type="number"
                style={{ width: "30px" }}
                className="form-control ml-2  p-1 py-1 text-center"
                value={pagenumber}
                onChange={(e) => {
                  if (!Number(e.target.value)) {
                    setPagenumber(e.target.value);
                    return;
                  }
                  if (e.target.value > pageCount) {
                    gotoPage(pageCount - 1);
                    setPagenumber(pageCount);
                    return;
                  }
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                  setPagenumber(e.target.value);
                }}
              />

              <PlayArrowIcon
                className="right-arrow"
                onClick={() => {
                  nextPage();
                  if (canNextPage) {
                    setPageno(pageno + 1);
                  }
                }}
                disabled={!canNextPage}
              />
              {/* <Pagination.Next
                onClick={() => {
                  nextPage();
                  if (canNextPage) {
                    setPageno(pageno + 1);
                  }
                }}
                disabled={!canNextPage}
              /> */}
            </Pagination>
          </Col>
          {/* <Col>
            <span className="d-flex align-items-center justify-content-end">
              <p className="px-1 mb-0">No.Of.Pages</p>
              <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">
                {pageCount}
              </button>
            </span>
          </Col> */}
          {/* <Col>
          <span className="d-flex align-items-center justify-content-end">
            <input
              type="number"
              className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control  text-center"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
              style={{ width: "40px" }}
            />
            <p className="px-1 mb-0">Page</p>{" "}
          </span>
        </Col> */}
        </Row>
      )}
    </div>
  );
}
